import { useSelector } from 'react-redux';

import { getShowroomWorkflowStatus } from '@makemydeal/dr-sales-checkin-store';

import { DEAL_SUMMARY_PDF_WORKFLOW_STATUSES } from './dealSummaryPdfWorkflowStatuses';

export const useDealSummaryPdfRequired = (): boolean => {
    const workflowStatus = useSelector(getShowroomWorkflowStatus);

    return DEAL_SUMMARY_PDF_WORKFLOW_STATUSES.includes(workflowStatus);
};
